import React, { HTMLAttributes, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";

import { get_searchMarketHot } from "api/old/xt-app";
import XtLoading from "@/components/Xt/Loading";
import AppDivNoData from "@/components/App/div/noData";

import { matchCfdSymbolMarginQuote } from "@/components/Pages/Market/MarketList/cfdTabListSource";

import CMPT_Main from "./main";

import styles from "./index.module.scss";

const { useTranslation } = Hooks;

interface Props extends HTMLAttributes<HTMLDivElement> {
  visible: boolean;
  setSearchInputFocus: () => void;
  isShowVolume: boolean;
  isCfd?: boolean;
  isFiatContract?: boolean;
  activeFiatQuote?: string | null;
}

const Main: React.FC<Props> = ({
  className,
  visible,
  setSearchInputFocus,
  isShowVolume,
  isCfd = false,
  isFiatContract = false,
  activeFiatQuote = null,
}) => {
  const t = useTranslation();

  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState<string[]>([]);

  useEffect(() => {
    if (!visible) return;
    setLoading(true);
    get_searchMarketHot()
      .then((data) => {
        const ary: string[] = [];
        data.map((obj) => {
          if (![1, 4].includes(obj.type)) return;
          const marketName = obj.marketName;
          if (!marketName || ary.includes(marketName)) return;
          if (!matchCfdSymbolMarginQuote(marketName, isFiatContract, isCfd, activeFiatQuote)) return;
          ary.push(marketName);
        });
        setRecords(ary);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [visible, isCfd, isFiatContract, activeFiatQuote]);

  return (
    <div className={cx(styles.main, className, { [styles.hide]: !visible })} onMouseDown={setSearchInputFocus} onTouchStart={setSearchInputFocus}>
      <div className={styles.nav}>{t("trade.topSearch")}</div>
      <div className={styles.content}>
        {loading && <XtLoading className={styles.loading} />}
        {!loading && !records.length && <AppDivNoData />}
        {visible && !loading && !!records.length && <CMPT_Main records={records} isShowVolume={isShowVolume} />}
      </div>
    </div>
  );
};

export default observer(Main);
